import React from 'react';
import parse from 'html-react-parser';
import {
	RichText as SitecoreRichText,
	RichTextField,
} from '@sitecore-jss/sitecore-jss-react';

import * as Typo from 'core/styles/Typography';

/**
 * Props for the Richtext component.
 * @property {RichTextField | string} content - The rich text content from Sitecore or a raw HTML string.
 */
interface IProps {
	content: RichTextField | string;
}

/**
 * Renders Sitecore rich text fields using the official JSS field renderer for full compatibility.
 * @param {IProps} props
 */
const Richtext: React.FC<IProps> = ({ content }) => {
	const extractRichTextValue = (content: any): string => {
		if (
			typeof content?.value === 'object' &&
			content?.value?.props?.jss?.value
		) {
			return content.value.props.jss.value;
		}
		if (typeof content?.value === 'string') {
			return content.value;
		}

		return '';
	};

	const getIsSubLayoutRichText = (content: any): string => {
		if (
			typeof content?.value === 'object' &&
			content?.value?.props?.isSubLayoutRichText
		) {
			return content?.value?.props?.isSubLayoutRichText;
		}

		return '';
	};

	if (typeof content === 'object' && content !== null && 'value' in content) {
		return (
			// NOTE [NJU] to fix sub-layout type and using richText
			getIsSubLayoutRichText(content) ? (
				<Typo.SubHeading tag="legend">
					<SitecoreRichText
						field={{
							value: extractRichTextValue(content as RichTextField),
						}}
						tag="span"
					/>
				</Typo.SubHeading>
			) : (
				<SitecoreRichText field={content as RichTextField} tag="" />
			)
		);
	}

	// NOTE [NJU] to fix issue with testing automation div issue
	if (typeof content === 'string') {
		return <>{parse(content)}</>;
	}

	return null;
};

export default Richtext;
